export default class {
  static if (value: boolean, jsx: JSX.Element): JSX.Element {
    if (value) {
      return jsx
    }
    return (<div style="display:none"></div>)
  }
}
